/**
 * Entry CDN IIFE — `window.MjlSpotlight`.
 * CSS produk di dalam JS; tidak fetch stylesheet terpisah.
 */
import { bus, clearConfig, getConfig, setConfig, type MjlSpotlightConfig } from '@mjl/shared';
import { SPOTLIGHT_TAG, registerSpotlight } from './mjl-spotlight';

export interface MjlSpotlightInitConfig {
  /** Opsional — override shortcut / placeholder UI */
  spotlight?: MjlSpotlightConfig;
}

export type MjlSpotlightGlobalType = {
  /** Opsional — override config UI; panel fetch data sendiri dari API */
  init: (config?: MjlSpotlightInitConfig) => void;
  destroy: () => void;
  open: () => void;
  close: () => void;
};

let el: HTMLElement | null = null;
let initialized = false;

function mount() {
  if (initialized) return;
  registerSpotlight();
  el = document.createElement(SPOTLIGHT_TAG);
  document.body.appendChild(el);
  initialized = true;
}

const MjlSpotlightGlobal: MjlSpotlightGlobalType = {
  init(config?: MjlSpotlightInitConfig) {
    if (config?.spotlight) {
      const existing = getConfig();
      setConfig({
        apps: existing?.apps,
        myApps: existing?.myApps,
        spotlight: config.spotlight,
      });
    }
    mount();
  },

  destroy() {
    el?.remove();
    el = null;
    const existing = getConfig();
    if (existing) {
      setConfig({
        apps: existing.apps,
        myApps: existing.myApps,
        spotlight: undefined,
      });
    } else {
      clearConfig();
    }
    initialized = false;
  },

  open() {
    bus.emit('spotlight:open');
  },

  close() {
    bus.emit('spotlight:close');
  },
};

declare global {
  interface Window {
    MjlSpotlight?: MjlSpotlightGlobalType;
  }
}

if (typeof window !== 'undefined') {
  window.MjlSpotlight = MjlSpotlightGlobal;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
}

export default MjlSpotlightGlobal;
